import { useQuery } from '@tanstack/react-query';
import { useApi } from '../../providers/ApiProvider';

export function useSavings({
  page = 1,
  perPage = 10,
  search = '',
  enabled = true,
  created_at = '',
}: {
  page?: number;
  perPage?: number;
  search?: string;
  enabled?: boolean;
  created_at?: string;
}) {
  const api = useApi();

  return useQuery({
    queryKey: ['savings', search, page, created_at], 
    queryFn: async () => {
      const res = await api.GET({
        endpoint: 'savings',
        params: { page, per_page: perPage, search, created_at },
      });
      return res;
    },
    enabled,
  });
}
